import React, { useState, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import moment from "moment";
import { orderBy } from "natural-orderby";
import ReactTooltip from "react-tooltip";

import { newFetch, GET, POST } from "../../helpers/fetch";

import { config } from "../../config";
const { SERVER_URL } = config;

const Catalogue = ({ history }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const clientID =
    user.site_associates.length > 0
      ? user.site_associates[0].site.client_id
      : null;

  // const [client, setClient] = useState(null)

  // const fetchClient = async (id) => {
  //   let api_path = `/client/${id}`
  //   let response = await newFetch(GET, api_path)
  //   if (response.success) {
  //     setClient(response.data)
  //   }
  // }

  // useEffect(() => {
  //   if (clientID) {
  //     fetchClient(clientID)
  //   }
  // }, [clientID])

  // const sortOptions = [
  //   "Title A-Z",
  //   "Title Z-A",
  //   "Latest to Oldest",
  //   "Oldest to Latest",
  // ];
  const [catalogues, setCatalogues] = useState([]);
  const [sortedEDocs, setSortedEDocs] = useState([]);
  const [activeSort, setActiveSort] = useState("Title A-Z");

  const fetchCatalogue = async () => {
    let api_path = `/catalogue/list`;
    let response = await newFetch(POST, api_path, {
      client_id: clientID,
    });

    if (response.success) {
      const catalogueData = response.data.list;
      setCatalogues(catalogueData);
    }
  };

  // useEffect(() => {
  //   if (client) setEDocs(client.edocs)
  // }, [client])

  useEffect(() => {
    fetchCatalogue();
  }, []);

  // const sortDocs = (data, option) => {
  //   let clone = JSON.parse(JSON.stringify([...data]))

  //   switch (option) {
  //     case 'Title A-Z':
  //       clone = orderBy(clone, [(edoc) => edoc.title], ['asc'])
  //       break

  //     case 'Title Z-A':
  //       clone = orderBy(clone, [(edoc) => edoc.title], ['desc'])
  //       break

  //     case 'Latest to Oldest':
  //       clone = clone.sort(
  //         (a, b) => moment(b.createdAt).unix() - moment(a.createdAt).unix()
  //       )
  //       break

  //     case 'Oldest to Latest':
  //       clone = clone.sort(
  //         (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix()
  //       )
  //       break

  //     default:
  //       break
  //   }

  //   return clone
  // }

  // useEffect(() => {
  //   //setSortedEDocs(sortDocs(eDocs, activeSort))
  // }, [activeSort, eDocs])
  return (
    <div>
      <div className="container pt-4">
        <h4 className="text-brand">
          <Link to="/">
            <i
              className="fas fa-arrow-left link"
              style={{ cursor: "pointer" }}
            />
          </Link>
          &nbsp;&nbsp;Catalogue
        </h4>
        <div className="catalogue-container pt-4">
          {catalogues.length > 0 ? (
            catalogues.map((item, index) => (
              <React.Fragment key={index}>
                <Link className="text-primary " to={`/catalogue/${item.id}`}>
                  <div className="catalogue-card-container">
                    <div className="catalogue-card">
                      <img
                        className="catalogue-card-img img-fluid"
                        src={`${SERVER_URL}/${item.images[0].new_image}`}
                        alt="Card image"
                      />
                    </div>
                    <div className="catalogue-text-center">
                      <span className="catalogue-card-title">{item.name}</span>
                    </div>
                  </div>
                </Link>
              </React.Fragment>
            ))
          ) : (
            <p>No Record Found</p>
          )}
        </div>
        {/* {eDocs &&
        eDocs.map(month => (
          <>
            <div className="border-bottom">
              <h6 className="pt-4 text-muted">{month.monthYear}</h6>
            </div>
            {month.events.map(event => (
              <div
                className="border-bottom bg-white"
                onClick={() => history.push(`/events/event/${event.id}`)}
              >
                <div className="d-flex">
                  <div style={{ minWidth: '70px' }}>
                    <div className="d-flex flex-column justify-content-center align-items-center text-center shadow rounded bg-white m-2 p-1">
                      <div
                        className="text-brand font-weight-bold"
                        style={{ fontSize: '1.2rem' }}
                      >
                        {moment(event.date).format('DD')}
                      </div>
                      <div
                        className="text-muted"
                        style={{ fontSize: '0.8rem' }}
                      >
                        {moment(event.date).format('MMM')}
                      </div>
                    </div>
                  </div>
                  <div className="flex-grow-1 d-flex flex-column m-2 p-1">
                    <div className="font-weight-bold mb-1">{event.title}</div>
                    <small className="text-muted w-100">
                      {_.truncate(event.description, { length: 38 })}
                    </small>
                  </div>
                </div>
              </div>
            ))}
          </>
        ))} */}
      </div>
    </div>
  );
};

export default withRouter(Catalogue);
